import { fullyDecodeRouteParam } from '~/utils/route'

export const useResolvedMenuRoute = async () => {
  const route = useRoute()
  const menuStore = useMenuStore()
  const normalizedSlug = computed(() => fullyDecodeRouteParam(String(route.params.slug || '')))
  const menu = computed(() =>
    menuStore.allList.find((item: Menu) => fullyDecodeRouteParam(item.slug) === normalizedSlug.value),
  )

  if (route.params.slug && !menu.value) {
    await menuStore.fetch()
  }

  if (route.params.slug && !menu.value) {
    throw createError({ statusCode: 404, statusMessage: 'Page not found' })
  }

  return {
    menu,
    normalizedSlug,
  }
}
